import { render, staticRenderFns } from "./KidDashboard.vue?vue&type=template&id=de2d78b2&scoped=true&"
import script from "./KidDashboard.vue?vue&type=script&lang=js&"
export * from "./KidDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KidDashboard.vue?vue&type=style&index=0&id=de2d78b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2d78b2",
  null
  
)

export default component.exports